import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { NewResponsibleCrubs } from 'practice/constants/responsabile-crubs';
import FormResponsible, { FormResponsibleVM } from 'practice/components/resonsible/form';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { AxiosPromise } from 'axios';
import { toast } from 'react-toastify';

const NewResponsible = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-responsabile');
  });

  const insertResponsible = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/responsabile/`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormResponsibleVM) => {
      const dataInsert = insertResponsible({
        data: {
          codResponsabile: values.responsible,
          key: {
            tipoPratica: values.practice,
            codServizio: values.service,
          },
        },
      }) as AxiosPromise;
      dataInsert.then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-responsabile');
      });
    },
    [insertResponsible, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={NewResponsibleCrubs} />
      <FormResponsible title="Nuovo Responsabile" onCancel={onCancel} onSubmit={onSubmit} />
    </Fragment>
  );
};

NewResponsible.displayName = 'New Responsible Page component';

export default NewResponsible;
